var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 11.9996C22.9997 9.89751 22.397 7.83953 21.2634 6.06931C20.1298 4.29908 18.5127 2.89074 16.6035 2.01101C14.6944 1.13128 12.5731 0.817004 10.4909 1.10538C8.40872 1.39377 6.45274 2.27273 4.85455 3.63822C3.25636 5.0037 2.08289 6.79853 1.47306 8.81022C0.863232 10.8219 0.842586 12.9662 1.41357 14.9893C1.98454 17.0123 3.12324 18.8294 4.69484 20.2254C6.26644 21.6214 8.20514 22.5379 10.2814 22.8663V15.1792H7.48871V11.9996H10.2814V9.57571C10.2814 6.81924 11.9236 5.29606 14.4355 5.29606C15.6391 5.29606 16.8982 5.51089 16.8982 5.51089V8.21818H15.5109C14.1444 8.21818 13.7186 9.06583 13.7186 9.93677V11.9996H16.7701L16.2822 15.1792H13.7199V22.8663C16.3071 22.4562 18.6631 21.1365 20.3642 19.1446C22.0653 17.1526 22.9999 14.6191 23 11.9996Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2818 15.1797L16.7697 12H13.7182V9.93722C13.7182 9.06627 14.1452 8.21863 15.5105 8.21863H16.8978V5.51133C16.8978 5.51133 15.6386 5.29651 14.4351 5.29651C11.9232 5.29651 10.281 6.81969 10.281 9.57616V12H7.48828V15.1797H10.281V22.8667C11.4197 23.0455 12.5794 23.0455 13.7182 22.8667V15.1797H16.2805",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.df79c99a78943431139df378e3f905a7.svg";
export { ForwardRef as ReactComponent };